module.exports = __webpack_public_path__ + "static/media/menu-evenements.6f3727c6.svg";